export default function defineNuxtRouterMiddleware(to: {
  path: string | string[]
}) {
  if (import.meta.server) return
  // 权限判断
  if (!(localStorage.getItem('ticket') && localStorage.getItem('loginInfo'))) {
    if (to.path === '/home' || to.path === '/') {
      return
    } else if (to.path.indexOf('/draftstatic/') !== -1) {
      return
    } else if (to.path === '/roomApp/audio' || to.path === '/roomApp/live') {
      return
    } else {
      return navigateTo('/')
    }
  } else {
    return
  }
  return
}
